import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import { toSendViaSf as _toSendViaSf } from '@/api/correspondence/task/form';
import awaitToJs from '@/libs/awaitToJs';
import { mapState } from 'vuex';
import { json2excel } from '@/util/json2excel';
export default {
  name: 'check-data',
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: {
      type: Number,
      default: function _default() {
        return 1;
      }
    },
    expressSendType: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    expressPayType: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isHX: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    isCpscAdmin: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    isAdmin: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    isSender: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    excelName: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var d, merge, _d;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // this.$emit('submit', this.tableData)
              _this.loading = true;
              if (!(_this.type === 1)) {
                _context.n = 2;
                break;
              }
              d = _this.tableData.map(function (item) {
                return [item.$id, item.form, item.sender, item.phone, item.address, item.c03CusName, item.c02ObjStaff, item.c02ObjMobile, item.$phone, item.c02ObjAddress, item.$fileType, item._codes.length, item.$zhongliang, item._codes.join(','), item.payType, item.type, 1];
              });
              _context.n = 1;
              return json2excel([_this.columns].concat(_toConsumableArray(d)), "".concat(_this.excelName ? _this.excelName : "".concat(_this.data[0].c02ConfirmCode, "_\u987A\u4E30\u53D1\u51FD\u5BFC\u5165\u6A21\u677F"), ".xlsx"));
            case 1:
              _context.n = 3;
              break;
            case 2:
              if (!(_this.type === 2)) {
                _context.n = 3;
                break;
              }
              merge = [{
                s: {
                  r: 0,
                  c: 1
                },
                e: {
                  r: 0,
                  c: 8
                }
              }, {
                s: {
                  r: 0,
                  c: 9
                },
                e: {
                  r: 0,
                  c: 16
                }
              }, {
                s: {
                  r: 0,
                  c: 17
                },
                e: {
                  r: 0,
                  c: 23
                }
              }, {
                s: {
                  r: 0,
                  c: 24
                },
                e: {
                  r: 0,
                  c: 26
                }
              }, {
                s: {
                  r: 0,
                  c: 27
                },
                e: {
                  r: 0,
                  c: 33
                }
              }, {
                s: {
                  r: 0,
                  c: 34
                },
                e: {
                  r: 0,
                  c: 35
                }
              }, {
                s: {
                  r: 0,
                  c: 36
                },
                e: {
                  r: 0,
                  c: 37
                }
              }, {
                s: {
                  r: 0,
                  c: 38
                },
                e: {
                  r: 0,
                  c: 52
                }
              }, {
                s: {
                  r: 0,
                  c: 53
                },
                e: {
                  r: 0,
                  c: 55
                }
              }, {
                s: {
                  r: 0,
                  c: 56
                },
                e: {
                  r: 0,
                  c: 57
                }
              }, {
                s: {
                  r: 0,
                  c: 58
                },
                e: {
                  r: 0,
                  c: 59
                }
              }, {
                s: {
                  r: 0,
                  c: 63
                },
                e: {
                  r: 0,
                  c: 66
                }
              }];
              _d = _this.tableData.map(function (item) {
                return [item.$id,
                // 收方信息
                item.c02ObjStaff, item.c02ObjMobile, item.$phone, item.c03CusName, item.$p, item.$c, item.$t, item.c02ObjAddress,
                // 寄方信息
                item.sender, item.phone, item._tel, item.form, item.$p2, item.$c2, item.$t2, item.address,
                // 货物信息
                item.$tuojiwu, item.$tuojiwushuliang, item.$baonangshu, item.$zhongliang, '', '', '',
                // 物流产品信息
                item.$express,
                // item.type,
                item.payType, item._Num, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', item._codes.join(','), item.$ext1, item.$ext2, item.$ext3];
              });
              _context.n = 3;
              return json2excel([].concat(_toConsumableArray(_this.columns), _toConsumableArray(_d)), "".concat(_this.name ? _this.name : "".concat(_this.data[0].c02ConfirmCode, "_\u987A\u4E30\u53D1\u51FD\u5BFC\u5165\u6A21\u677F"), ".xlsx"), merge);
            case 3:
              _this.loading = false;
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    chunkArray: function chunkArray(arr, len) {
      var chunks = Array.from({
        length: Math.ceil(arr.length / len)
      }, function (_, i) {
        return arr.slice(i * len, i * len + len);
      });
      return chunks;
    },
    toSendViaSf: function toSendViaSf() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res, dataList, index, sendData, self, send, _send;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _send = function _send3() {
                _send = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(items) {
                  var _yield$awaitToJs, _yield$awaitToJs2, err, data;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        self.loading = true;
                        _context2.n = 1;
                        return awaitToJs(_toSendViaSf(items));
                      case 1:
                        _yield$awaitToJs = _context2.v;
                        _yield$awaitToJs2 = _slicedToArray(_yield$awaitToJs, 2);
                        err = _yield$awaitToJs2[0];
                        data = _yield$awaitToJs2[1];
                        self.loading = false;
                        if (!err) {
                          _context2.n = 2;
                          break;
                        }
                        return _context2.a(2, Promise.reject(err));
                      case 2:
                        self.orderMessage = data;
                        index++;
                        if (sendData[index]) {
                          send(sendData[index]);
                        } else {
                          self.loading = false;
                        }
                      case 3:
                        return _context2.a(2);
                    }
                  }, _callee2);
                }));
                return _send.apply(this, arguments);
              };
              send = function _send2(_x) {
                return _send.apply(this, arguments);
              };
              _this2.loading = true;
              res = _this2.tableData.some(function (item) {
                return !item._Num || !item._COde;
              });
              if (!res) {
                _context3.n = 1;
                break;
              }
              _this2.$message.warning('月结卡号或组织编码不能为空');
              return _context3.a(2);
            case 1:
              dataList = _this2.tableData.map(function (item) {
                var _item$c02ObjMobile;
                return {
                  sendName: item.sender,
                  sendAddress: item.address,
                  sendTel: item.phone,
                  receiveName: item.c02ObjStaff,
                  receiveAddress: item.c02ObjAddress,
                  receiveTel: (_item$c02ObjMobile = item.c02ObjMobile) !== null && _item$c02ObjMobile !== void 0 ? _item$c02ObjMobile : item.$phone,
                  payType: isNaN(item._payType) ? item._payType : +item._payType,
                  productCodes: item._codes,
                  account: item._Num,
                  orgCode: item._COde,
                  sendCompany: item.form,
                  receiveCompany: item.c03CusName
                };
              });
              index = 0;
              sendData = _this2.chunkArray(dataList, 10);
              self = _this2;
              send(sendData[index]);
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  },
  data: function data() {
    return {
      tableData: [],
      loading: false,
      orderMessage: {
        succeeded: [],
        failed: []
      }
    };
  },
  created: function created() {
    var _this3 = this;
    this.tableData = this.data.map(function (item) {
      var p = _this3.expressPayType.find(function (sub) {
        return sub.label === item.payType;
      });
      return _objectSpread(_objectSpread({}, item), {}, {
        $id: undefined,
        $p: undefined,
        $c: undefined,
        $t: undefined,
        $express: _this3.type === 1 ? '' : '顺丰',
        $tuojiwu: _this3.type === 1 ? '' : '函证文件',
        $tuojiwushuliang: undefined,
        $baonangshu: undefined,
        $zhongliang: undefined,
        $p2: undefined,
        $c2: undefined,
        $t2: undefined,
        $ext1: undefined,
        $ext2: undefined,
        $ext3: undefined,
        $phone: undefined,
        $fileType: '文件',
        _payType: p ? p.value : item.payType
      });
    });
  }
};